import neoshiftIcon from '../images/NeoshiftIcon.svg';

const BADGE_URL = 'https://neoshift.ai/?ref=public_dashboard_badge';

export default function PublicWatermarkBadge() {
  return (
    <a
      href={BADGE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 px-3 py-1.5 bg-white dark:bg-surface-800 rounded-full shadow-md hover:shadow-lg hover:bg-surface-50 dark:hover:bg-surface-700 transition-all duration-200 group"
    >
      <img src={neoshiftIcon} alt="Neoshift" className="w-4 h-4 flex-shrink-0 rounded-sm" />
      <span className="text-xs font-medium text-surface-500 dark:text-surface-400 group-hover:text-surface-700 dark:group-hover:text-surface-200 transition-colors whitespace-nowrap">
        Powered by Neoshift
      </span>
    </a>
  );
}
